import React from "react";
import { Flex, Link, Box, Text, SimpleGrid, Image, Spacer, IconButton, Tooltip } from "@chakra-ui/react";
import { GiAerialSignal } from "react-icons/gi";
import { BsGithub } from "react-icons/bs";
import { ChapterHeading, Reveal, MotionBox, glass } from "./story";

import chatApp from "../Assets/chatApp.png";
import fileSharingApp from "../Assets/fileSharing.png";
import nnnow from "../Assets/nnnow.png";
import todo from "../Assets/todo_home.png";
import tictactoe from "../Assets/tictactoe.png";

const projectData = [
  {
    name: "Chat Application",
    img: chatApp,
    desc: `A live messaging app with a friendly interface. Sign up, customise your profile, search users, and chat privately or in groups with admin controls and instant notifications.`,
    github: "https://github.com/mukulsomukesh/chat-application/",
    deploy: "https://chat-app-ca.netlify.app/",
    stack: "React · Node · Express · MongoDB · Socket.io · Tailwind",
  },
  {
    name: "File Sharing App",
    img: fileSharingApp,
    desc: `Upload a file, protect it with a password, and share it through a generated link. Owners can update, delete, or change the password anytime, secure sharing made simple.`,
    github: "https://github.com/mukulsomukesh/file-sharing-app",
    deploy: "https://file-sharing-application.netlify.app/",
    stack: "React · Node · Express · MongoDB · Redux · Chakra UI",
  },
  {
    name: "NNNOW Clone",
    img: nnnow,
    desc: `A complete online store with product search by name and category, filters, sorting, cart, wishlist, and an admin panel to manage the whole catalogue.`,
    github: "https://github.com/mukulsomukesh/trendy-vibes",
    deploy: "https://trendy-vibes-imdebabrata-imdebabrata.vercel.app/",
    stack: "React · Node · Express · MongoDB · Redux · Chakra UI",
  },
  {
    name: "TODO Application",
    img: todo,
    desc: `A super simple productivity app. Sign up, then create, update, and delete tasks with an interface designed to get out of your way and keep you organised.`,
    github: "https://github.com/mukulsomukesh/TODO",
    deploy: "https://lighthearted-fox-2d89be.netlify.app/signup",
    stack: "React · Node · Express · MongoDB · Redux · Chakra UI",
  },
  {
    name: "Tic Tac Toe",
    img: tictactoe,
    desc: `A polished take on a classic. Play a friend locally or challenge the computer, with clean state management and a modern, responsive interface.`,
    github: "https://github.com/mukulsomukesh/tic-tac-toe",
    deploy: "https://tic-tac-toe-mj.netlify.app/",
    stack: "React · Redux · Chakra UI",
  },
];

export default function Project() {
  return (
    <Box id="Projects" py={{ base: "80px", md: "120px" }} px={{ base: "6%", md: "9%" }}>
      <ChapterHeading
        chapter="Chapter 05 · The Craft"
        title="Things I've built"
        subtitle="Side projects where I get to experiment, break things, and learn. Each one a small story of its own."
      />

      <SimpleGrid maxW="1150px" mx="auto" spacing="26px" columns={{ base: 1, md: 2, lg: 3 }}>
        {projectData.map((item, i) => (
          <Reveal key={item.name} delay={(i % 3) * 0.1}>
            <MotionBox
              whileHover={{ y: -8 }}
              transition={{ type: "spring", stiffness: 250 }}
              {...glass({ overflow: "hidden", p: 0 })}
              h="100%"
              _hover={{ borderColor: "#60A5FA", boxShadow: "0 14px 40px rgba(96,165,250,0.25)" }}
              display="flex"
              flexDirection="column"
            >
              <Box overflow="hidden" h="190px">
                <Image
                  src={item.img}
                  alt={item.name}
                  w="100%"
                  h="100%"
                  objectFit="cover"
                  transition="transform 0.5s"
                  _hover={{ transform: "scale(1.06)" }}
                />
              </Box>

              <Box p="18px" display="flex" flexDirection="column" flex="1">
                <Flex align="center">
                  <Text color="#f0f2f7" fontSize="xl" fontWeight="800">
                    {item.name}
                  </Text>
                  <Spacer />
                  <Tooltip label="Live preview" hasArrow bg="#60A5FA" color="white">
                    <Link href={item.deploy} isExternal>
                      <IconButton
                        aria-label="Live preview"
                        variant="ghost"
                        size="sm"
                        isRound
                        color="#98a2b8"
                        _hover={{ bg: "#60A5FA", color: "white" }}
                        icon={<GiAerialSignal size="22px" />}
                      />
                    </Link>
                  </Tooltip>
                  <Tooltip label="Source code" hasArrow bg="#60A5FA" color="white">
                    <Link href={item.github} isExternal>
                      <IconButton
                        aria-label="Source code"
                        variant="ghost"
                        size="sm"
                        isRound
                        color="#98a2b8"
                        _hover={{ bg: "#60A5FA", color: "white" }}
                        icon={<BsGithub size="20px" />}
                      />
                    </Link>
                  </Tooltip>
                </Flex>

                <Text mt="10px" fontSize="sm" color="#c2c9d6" lineHeight="1.8" flex="1">
                  {item.desc}
                </Text>

                <Text mt="14px" fontSize="xs" color="#7d879c" fontWeight="600" letterSpacing="0.02em">
                  {item.stack}
                </Text>
              </Box>
            </MotionBox>
          </Reveal>
        ))}
      </SimpleGrid>
    </Box>
  );
}
